class pricelist {
    constructor(jsondata) {

        this.name = '';
        this.plcategories = [];
        this.useroptions = {};
        this.ajaxurl = '/wp-admin/admin-ajax.php';
        this.isEditShown = false;
        this.type = getQueryVariable('type') ? getQueryVariable('type') : 'long';
        this.date = false;
        this.content = getQueryVariable('content') ? getQueryVariable('content') : 'new';
        this.languages = ['de', 'en', 'fr'];
        this.language = 'de';
        this.isDirty = false;
        this.showPrices = true;
        this.hasCustomTitle = false;
        this.plen = 'Price List';
        this.plde = 'Preisliste';
        this.plfr = 'totalité des tarifs';
        this.alen = 'Article List';
        this.alde = 'Artikelliste';
        this.alfr = 'liste d\'article';

        //constructor for creating the pricelist from an existing config or new
        if (jsondata != null && jsondata.id > 1){
            this.id = jsondata.id;
            this.name = jsondata.name;
            this.useroptions = jsondata.userData.useroptions;
            this.language = jsondata.userData.lang;
            this.type = jsondata.userData.type;
            this.date = jsondata.date;
            this.showPrices = jsondata.userData.showPrices;
            this.saveButtonText = translations.preisliste_aktualisieren;

            this.render();

        } else {
            this.id = getFlalseID();
            this.saveButtonText = translations.preisliste_speichern;
            this.render();
            this.renderEditView();
            this.canBeSaved();
            this.setDefaultTitle('true');
        }


    }

    view() {
        return $(this.getSelector());
    }

    getSelector(){
        return `.pricelist[data-key="${this.id}"]`;
    }

    setDefaultTitle(){
        if ( this.language == 'de'  ) {
            var title = 'Spaltfix ' + ( this.showPrices === true ? this.plde : this.alde );
        } else if ( this.language == 'fr' ) {
            var title = 'Spaltfix ' + ( this.showPrices === true ? this.plfr : this.alfr );
        } else  {
            var title = 'Spaltfix '+ ( this.showPrices === true ? this.plen : this.alen );
        }

        if (this.type == 'short' && this.content == 'new' && this.hasCustomTitle == false){
            this.view().find('input#newtitle').val( title )
        }
    }

    canBeSaved(){
        if (this.type === 'long') {
            if ( this.plcategories[1].options.find(x=> x.isSelected) || this.plcategories[3].options.find(x=> x.isSelected) || this.plcategories[4].options.find(x=> x.isSelected) ){
                this.view().find('a.confirm-pricelist').removeClass('disabled');
                return true;
            } else {
                this.view().find('a.confirm-pricelist').addClass('disabled');
                return false;
            }
        } else {
            if (true ){
                this.view().find('a.confirm-pricelist').removeClass('disabled');
                return true;
            } else {
                this.view().find('a.confirm-pricelist').addClass('disabled');
                return false;
            }
        }

    }

    setLanguage(lang){
        this.language = lang;
        this.view().find('.lang-select .value').html(this.language);
        this.setDefaultTitle();
    }


    render() {
        let titleTemplate = `${this.date ? ` <span class="date">${this.date}</span> ` : ``}
                    <span class="title" >${this.name}</span >
                    <input id="newtitle" placeholder="${translations.produktauswahl}" value="${this.name}">
                   <a class="newtitlesave" href="#">OK</a>`;

        let titleTemplateNew = `<span class="label" >${translations.titel}*:</span ><input id="newtitle" value="">`;

        let tt = '';
        if ( this.content === 'new' ){
            tt = titleTemplateNew
        } else tt = titleTemplate;

        let template = `
            <div class="pricelist" data-key="${this.id}">
            <div class="pricelist-title" >
                <div class="left">
                    ${tt}
                    <div class="price-select">
                        <input type="radio" name="priceselect-${this.id}" value="true" ${this.showPrices ? 'checked' : ''}> ${translations.preisliste}
                        <input type="radio" name="priceselect-${this.id}" value="false" ${this.showPrices ? '' : 'checked'}> ${translations.artikelliste}
                    </div>
                    <div class='lang-select'>${translations.sprache}: 
                        <div class="drop-container">
                            <div class="value">${this.language}</div>
                            <div class="lang-dropdown">
                                ${this.languages.map( lang => `<div class="option">${lang}</div>` ).join('')} 
                            </div>
                        </div>
                    </div>

                </div>
                ${ ( this.content === 'all' ) ? ` 
                <div unselectable="on" class="menu">
                    <div class="toggle">&middot;&middot;&middot;</div>
                    <ul>
                        <li class="delete">${translations.loschen}</li>
                        <li class="rename">${translations.umbennenen}</li>
                        <li class="edit">${translations.andern}</li>
                        <li class="download">${translations.herunterladen}</li>
                    </ul>
                </div>
            ` : '' }

            </div>
            <div class="clearfix"></div>
            </div>
            `;

        $('.pricelist-container').append(template);
        if ( this.content === 'new' ){
            $('.pricelist .pricelist-title input').show();
        }

    }

    renderEditView(){
        if ( this.isEditShown === true ) { return }
        this.isEditShown = true;
        this.view().addClass('edit');
        this.getCategories();
        let template = `<div class="nav">
                ${this.plcategories.map((el) =>
            `<a href="#" data-key="${el.datakey}" class="list-group-item ${el.status}">
                    <div class="content">
                    ${el.name}
                     <svg xmlns="http://www.w3.org/2000/svg" width="14.821" height="8.452" viewBox="0 0 14.821 8.452">
                      <g id="Arrow" transform="translate(1.061 1.061)">
                        <line id="Line_57" data-name="Line 57" x1="6.327" y1="6.331" transform="translate(0 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        <line id="Line_58" data-name="Line 58" y1="6.331" x2="6.327" transform="translate(6.373 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                      </g>
                    </svg>
                   <div class="lds-dual-ring loading-nav-icon"></div>
                    </div>
                    <div class="selected">${translations.auswahl_i} (<span class="num">${ el.pricelist.getUserSelected(el.datakey).length}</span>)</div>
                    </a>
                     ${el.render()}
                    
                     `).join('')}
                
                 <div class="button-container">
                         <a href="#" class="confirm-pricelist button disabled">
                            ${this.saveButtonText}<span class="lds-dual-ring"></span>
        
                        </a>
                        <a href="#" class="button download-pricelist disabled" >${translations.herunterladen}<span class="lds-dual-ring"></span>
                        </a>
                 </div>
               
            </div>

           
            
            `;

        this.view().append(template);
        this.view().find('.menu .edit').addClass('active');

    }

    closeEditView(){
        this.isEditShown = false;
        this.view().removeClass('edit');
        this.view().find('.nav, .dropdown-container').remove();
        this.view().find('.menu .edit').removeClass('active');
    }

    //inits the category dropdowns
    getCategories() {
        console.log(translations);
        this.plcategories = [];
        if (this.type === 'long'){
            this.plcategories.push(new plcategory(translations.Produktkategorie,  'categories', this));
            this.plcategories.push(new plcategory(translations.produkt,  'products', this, 'categories'));
            this.plcategories.push(new plcategory(translations.stammbeschickung,  'logcharging', this ));
            this.plcategories.push(new plcategory(translations.scheithandling, 'loghandling', this ));
            this.plcategories.push(new plcategory(translations.zusatzprodukte,  'accessories', this));
        }
    }

    getUserSelected(cat){
        let useroptions = this.useroptions[cat];
        if (typeof useroptions != 'undefined'){
            return this.useroptions[cat];
        } else {
            return [];
        }
    }


    savePricelist(command){
        if (this.view().find('input#newtitle').val() < 1 ){
            message('Titel ist erforderlich');
            var instance = new Tooltip($('input#newtitle'),{
                title: 'Pflichtfeld',
                html: true,
                placement: 'top',
                trigger: 'click',
                closeOnClickOutside: true,
                offset: '0, 45px'
            });
            instance.show();
            return false;

        }

        this.view().find('a.confirm-pricelist').addClass('loading disabled');
        //set name
        this.name = this.view().find('input#newtitle').val();
        //set showprices
        this.showPrices = ( this.view().find('input:radio:checked').val() == 'true' );

        message(translations.preisliste_wird_gespeichert);

        let newUserOptions = {};

        this.plcategories.forEach(cat => {
            cat.options.forEach(option => {
                if ( option.isSelected ) {
                    if ( !newUserOptions.hasOwnProperty(cat.datakey)){
                        newUserOptions[cat.datakey] = []
                    }
                    newUserOptions[cat.datakey].push({id: option.id, name: option.name, parentid: cat.id  })
                }
            })
        });

        this.useroptions = newUserOptions;
        console.log(typeof this.useroptions );
        console.log(JSON.stringify(this.useroptions));
        let originalID = this.id;

        let self = this;
        $.ajax({
            type: 'get',
            url: this.ajaxurl,
            data: {
                action: 'savePricelist',
                command: command,
                id: this.id,
                json: JSON.stringify({type: this.type, lang: this.language, showPrices: this.showPrices, useroptions: this.useroptions}),
                name: this.name
            },
            success: function (data) {
                if (data > 0){
                    self.id = parseInt(data);
                    $('.pricelist[data-key='+originalID+']').attr('data-key', self.id);
                    message(translations.preisliste_erfolgreich_gespeichert);
                    console.log('PL id:' + data);
                    self.view().find('.button.download-pricelist').removeClass('disabled');
                    self.view().find('a.confirm-pricelist').html(translations.preisliste_aktualisieren);
                    self.view().find('a.download-pricelist').removeClass('disabled');
                    self.isDirty = false;
                } else {
                    message(translations.fehler);
                }

                $('.new-pricelist.new').fadeIn('fast');
            },
            error: function(data){
                message('Internal Server Error');
                console.log(data);
            },
            complete: function() {
                self.view().find('a.confirm-pricelist').removeClass('loading disabled');
            }
        })
    }



    showConfirmDialog(){
        let self = this;
        $('.confirm a.cancel').click(function() {
            $('.confirm').fadeOut('fast');
        });
        $('.confirm a.delete').click(function() {
            self.deletePricelist();
            $('.confirm').fadeOut('fast');
        });
        $('.confirm').fadeIn('fast');
    }

    deletePricelist(){
        let self = this;
        self.view().fadeOut('300', function () {
            self.view().remove();
        });
        $.ajax({
            type: 'get',
            url: self.ajaxurl,
            data: {
                action: 'savePricelist',
                command: 'delete',
                id: this.id,
                json: JSON.stringify(this.useroptions),
                name: name
            },
            success: function (data) {
                if (data !== false){
                    message(translations.pricelist_geloscht);
                } else {
                    message(translations.fehler);
                }
            },
            error: function (data) {
                message('Internal Server error');
            }
        })
    }

    renamePricelist(){
        let $title = this.view().find('.pricelist-title .title');
        $title.hide();
        this.view().find('input#newtitle').val($title.html());
        this.view().find('input#newtitle, a.newtitlesave').show();

    }
    renamePricelistSave(name){
        this.name = name;
        let $title = this.view().find('.pricelist-title .title');
        this.savePricelist();
        $title.html(name);
        $title.show();
    }

    download(){
        this.view().find('a.download-pricelist').addClass('loading');
        message(translations.pdf_wird_erstellt);
        $('body').addClass('busy');
        var this_ = this;
        $.ajax({
            type: 'post',
            url: '/wp-json/api/v1/pdf/',
            dataType: 'binary',
            data: {id: this.id},

            success: function (data) {
                if (data !== false){

                    var blob = new Blob([data]);
                    if (navigator.msSaveOrOpenBlob) {
                        navigator.msSaveOrOpenBlob(blob, this_.name + '.pdf');
                    } else {
                        var temp_link = document.createElement('a');
                        temp_link.href = URL.createObjectURL(blob);
                        temp_link.download = this_.name + '.pdf';
                        temp_link.type = "application/pdf";
                        document.body.appendChild(temp_link);
                        temp_link.click();
                        temp_link.remove();
                    }

                } else {
                    message(translations.felher_beim_herunterladen);
                }
            },
            error: function (data) {
                message('Internal Server error');
            },
            complete: function(){
                this_.view().find('a.download-pricelist').removeClass('loading disabled');
                $('body').removeClass('busy');
            }
        })
    }
}